// Google Analytics manager
let initialized = false;

export const initializeGoogleAnalytics = () => {
  try {
    if (!initialized && typeof window !== "undefined" && process.env.REACT_APP_ENVIRONMENT === "production") {
      // Load the Google Analytics script
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.GATSBY_GA4_ID}`;
      document.head.appendChild(script);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', process.env.GATSBY_GA4_ID, {
        anonymize_ip: true,
        cookie_expires: 0
      });

      // Assign gtag to window
      window.gtag = gtag;
      initialized = true;
    } else if (process.env.REACT_APP_ENVIRONMENT !== "production") {
      console.log("Google Analytics not initialized: non-production environment");
    }
  } catch (error) {
    console.error("Error initializing Google Analytics:", error);
  }
};

export const resetGoogleAnalytics = () => {
  if (typeof window !== "undefined" && initialized) {
    // Delete any existing GA cookies
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.indexOf('_ga') === 0 || cookie.indexOf('_gid') === 0) {
        const cookieName = cookie.split('=')[0];
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
      }
    }
    initialized = false;
  }
};